import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import type {
  CampoOrdenacaoLeadPreVendas,
  ListaLeadsPreVendas,
  MetaPreVendas,
  OrigemPreVendas,
  ResultadoPreVendas,
} from '../types'

import { api } from '@/lib/api-client'

const CHAVE = 'pre-vendas'

export function usePreVendas(data?: string, origem: OrigemPreVendas = 'inbound') {
  return useQuery({
    queryKey: [CHAVE, origem, data ?? 'hoje'],
    queryFn: async () => {
      const { data: resultado } = await api.get<ResultadoPreVendas>('/api/pre-vendas', {
        params: { origem, ...(data ? { data } : {}) },
      })
      return resultado
    },
    // Trocar o dia mantém o anterior visível enquanto o novo carrega.
    placeholderData: (anterior) => anterior,
  })
}

export interface ConsultaLeadsPreVendas {
  data?: string
  origem: OrigemPreVendas
  page: number
  perPage: number
  sortBy: CampoOrdenacaoLeadPreVendas
  sortDir: 'asc' | 'desc'
  search?: string
  sdr?: string
  etapa?: string
}

export function useLeadsPreVendas(consulta: ConsultaLeadsPreVendas) {
  return useQuery({
    queryKey: [CHAVE, 'leads', consulta],
    queryFn: async () => {
      const { data } = await api.get<ListaLeadsPreVendas>('/api/pre-vendas/leads', {
        params: consulta,
      })
      return data
    },
    // Trocar página/filtro mantém a lista anterior visível enquanto carrega.
    placeholderData: (anterior) => anterior,
  })
}

export function useMetasPreVendas(origem: OrigemPreVendas = 'inbound') {
  return useQuery({
    queryKey: [CHAVE, 'metas', origem],
    queryFn: async () => {
      const { data } = await api.get<{ metas: MetaPreVendas[] }>('/api/pre-vendas/metas', {
        params: { origem },
      })
      return data.metas
    },
  })
}

export function useSalvarMetasPreVendas(origem: OrigemPreVendas = 'inbound') {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (metas: MetaPreVendas[]) => {
      const { data } = await api.put<{ salvas: number }>('/api/pre-vendas/metas', { origem, metas })
      return data
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [CHAVE] }),
  })
}
